var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg027Stop = function Svg027Stop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.717 31 0 256l124.717 225h262.566L512 256 387.283 31zm227.22 390H160.063L68.599 256l91.465-165h191.873l91.465 165z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m177.729 121-74.824 135 74.824 135h156.542l74.824-135-74.824-135z"
  })));
};
export default Svg027Stop;